<template>
  <Row>
    <Row type="flex" justify="end" style="margin:12px 0">
      <Page
        show-total
        :total="page.total"
        size="small"
        @on-change="changePage"
        show-sizer
        :page-size="page.limit > 0 ? page.limit : page.total"
        @on-page-size-change="changeLimit"
        :page-size-opts="[0, 10, 20, 30, 40, 50, 60, 120]"
      ></Page>
      <i-button size="small" @click="download">
        <FFIcon type="download" aria-hidden="true" />download
      </i-button>
    </Row>

    <Row>
      <AgGridVue
        style="width: 100%; height: 640px;"
        class="ag-theme-balham"
        :rowData="dataset"
        :columnDefs="columnDefs"
        :gridOptions="gridOptions"
      ></AgGridVue>
    </Row>

    <Row type="flex" justify="end" style="margin:12px 0">
      <Page
        show-total
        :total="page.total"
        size="small"
        @on-change="changePage"
        show-sizer
        :page-size="page.limit > 0 ? page.limit : page.total"
        @on-page-size-change="changeLimit"
        :page-size-opts="[0, 10, 20, 30, 40, 50, 60, 120]"
      ></Page>
      <i-button size="small" @click="download">
        <FFIcon type="download" aria-hidden="true" />download
      </i-button>
    </Row>
  </Row>
</template>

<script>
import tableActions from "@/mixins/table_actions";
import pagination from "@/mixins/pagination";
import sort from "@/mixins/sort";
import { AgGridVue } from "ag-grid-vue";
import CopyButton from "@/grid-components/copy-button.vue";
import LinkComponent from "@/grid-components/link.vue";
import TagsComponent from "@/grid-components/tags";

export default {
  components: {
    AgGridVue,
    /* eslint-disable vue/no-unused-components */
    CopyButton,
    /* eslint-disable vue/no-unused-components */
    LinkComponent,
  },
  mixins: [tableActions, pagination, sort],
  props: ["conditions", "limit", "lastVisited", "hack"],
  data() {
    return {
      tableURL: "facts_view",
      tableDownloadURL: "facts_download_view",
      dataset: [],
      gridOptions: {
        sideBar: {
          toolPanels: ["columns", "filters"],
          defaultToolPanel: "",
        },
        defaultColDef: {
          sortable: true,
          resizable: true,
          filter: true,
        },
        enableRangeSelection: true,
        allowContextMenuWithControlKey: true,
        getContextMenuItems: params => [
          {
            name: "Copy URL",
            action: () => {
              // console.log(params.node.data);
              this.copyClipboard(params.node.data);
            },
          },
          "separator",
          ...params.defaultItems,
        ],
      },
      columnDefs: Object.freeze([
        {
          suppressMenu: true,
          resizable: false,
          headerName: "IDU",
          field: "idu",
          width: 50,
          enableRowGroup: true,
          cellRenderer: params => {
            if (params.node.data) {
              return params.node.data.idu
                ? '<i class="fa fa-check-circle"></i>'
                : "";
            }
          },
        },
        {
          headerName: "Name",
          field: "name",
          width: 250,
          cellRendererFramework: LinkComponent,
          cellRendererParams: {
            link: data => `/facts/${data.id}`,
            name: data => data.name,
          },
        },
        { headerName: "Country", field: "country", enableRowGroup: true },
        {
          headerName: "Figure",
          field: "figure",
          valueFormatter: ({ value }) => {
            if (!!value) {
              return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
            } else {
              return "";
            }
          },
          width: 90,
        },
        {
          headerName: "Reported Figure",
          field: "reported_figure",
          hide: true,
        },
        { headerName: "Type", field: "type", enableRowGroup: true },
        {
          headerName: "Groups",
          field: "groups",
          cellRendererFramework: TagsComponent,
          cellRendererParams: {
            items: data => data.groups || [],
          },
        },
        {
          headerName: "Themes",
          field: "themes",
          cellRendererFramework: TagsComponent,
          cellRendererParams: {
            items: data => data.themes || [],
          },
          hide: true,
        },
        { headerName: "Year", field: "year", width: 70, enableRowGroup: true },
        {
          headerName: "Start Date",
          field: "start_date",
          valueFormatter: params =>
            params.data.type.includes("Flow") ? params.data.start_date : "",
          width: 120,
        },
        {
          headerName: "Cause",
          field: "displacement_type",
          width: 90,
          enableRowGroup: true,
        },
        {
          headerName: "Class",
          field: "class",
          width: 70,
          enableRowGroup: true,
        },
        {
          headerName: "Role (Event)",
          field: "event_role",
          enableRowGroup: true,
        },
        {
            headerName: "Included in GRID (Event)",
            field: "event_data_included",
            width: 180,
            cellRenderer: params => (params.value ? '<i class="fa fa-check-circle"></i>': ""),
        },
        {
          headerName: "Role (Master)",
          field: "parent_role",
          enableRowGroup: true,
        },
        {
          headerName: "Event Name",
          field: "event_name",
          width: 250,
          cellRendererFramework: LinkComponent,
          cellRendererParams: {
            link: data => `/events/${data.event_id}`,
            name: data => data.event_name,
          },
        },
        {
          headerName: "Hazard Subtype",
          field: "hazard_subtype",
          enableRowGroup: true,
        },
        {
          headerName: "Created by",
          field: "created_by",
          enableRowGroup: true,
        },
        {
          headerName: "Region",
          field: "region",
          enableRowGroup: true,
          hide: true,
        },
        {
          headerName: "Stock Date",
          field: "stock_date",
          valueFormatter: params =>
            params.data.type.includes("Stock") ? params.data.stock_date : "",
          width: 120,
          hide: true,
        },
        {
          headerName: "End Date",
          field: "end_date",
          valueFormatter: params =>
            params.data.type.includes("Flow") ? params.data.end_date : "",
          width: 120,
          hide: true,
        },
        {
          headerName: "Public Figure Analysis",
          field: "public_figure_analysis",
          width: 120,
          hide: true,
        },
        { headerName: "GSN", field: "gsn", width: 140, hide: true },
        {
          headerName: "Status",
          field: "status",
          enableRowGroup: true,
          hide: true,
        },
        { headerName: "Qualifier", field: "qualifier", hide: true },
        {
          headerName: "Excerpt",
          field: "excerpt_text",
          hide: true,
        },
        {
          headerName: "Sources",
          field: "sources",
          cellRendererFramework: TagsComponent,
          cellRendererParams: {
            items: data => data.sources || [],
          },
          hide: true,
        },
        { headerName: "Created at", field: "created_at", hide: true },
      ]),
    };
  },

  created() {
    this.load();
  },

  watch: {
    conditions() {
      this.load();
    },
    hack() {
      this.$nextTick(() => {
        console.log("hack");

        this.gridOptions.api.redrawRows();
      });
    },
  },
  methods: {
    copyClipboard(data) {
      // const link = `${window.location.toString()}/${data.id}`;
      const link = `${window.origin}/facts/${data.id}`;
      this.$copyText(link).then(
        () => this.$Message.success("Link copied to clipboard"),
        () => this.$Message.error("Can't copy link")
      );
    },
    onGridReady(params) {
      this.gridOptions.gridApi = params.api;
      this.gridOptions.columnApi = params.columnApi;
      this.gridOptions.api.sizeColumnsToFit();
      this.gridOptions.columnApi.autoSizeColumns();
      params.api.redrawRows();
    },

    downloadFiltered() {
      const allCols = this.gridOptions.columnApi.columnController.gridColumns;
      let visibleCols = allCols
        .filter(x => x.visible && x.colDef.field[0] !== "_")
        .map(x => x.colDef.field);
      if (visibleCols.indexOf("id") < 0) {
        visibleCols = ["id", ...visibleCols];
      }
      this.download(visibleCols.toString());
    },

    icon(value) {
      switch (value) {
        case "Under Review":
          return "search";
        case "Review Completed":
          return "check";
        case "Signed Off":
          return "pencil";
        case "Locked Down":
          return "lock";
        default:
          return "";
      }
    },
  },
};
</script>

<style lang="css">
.ivu-table-small td {
  height: 32px;
}

.comment {
  color: #5c738e;
}
.search {
  color: #dc722d;
}
.check {
  color: #748a5a;
}
.pencil {
  color: #50a090;
}
.lock {
  color: #296ca2;
}
.hash {
  color: gray;
}
</style>
